module.exports = __webpack_public_path__ + "img/Card 3.cf642f67.png";